<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <div class="bc_ico">
            <a href="javascript:" @click="goMain">Home</a>
            <em><span class="sr_only">&gt;</span></em>
            {{ $t('TITLE.MYKNOWLEDGE.USERPREFERENCES') }}
        </div>
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ $t('TITLE.MYKNOWLEDGE.USERPREFERENCES') }}</h2>

        <!--list table-->
        <div class="grid_wrap">
            <!-- //my Menu tit -->
            <div class="sub_tit w100p">
                {{ $t('TITLE.GLOBAL.MYMENUS') }}
                <a v-if="!isMobile" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnMyMenuConfig">
                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                </a>
            </div>
            <table class="scroll_table">
                <colgroup>
                    <col width="33.3%" />
                    <col width="33.3%" />
                    <col width="*" />
                </colgroup>
                <thead>
                    <tr>
                        <th>{{ $t('FIELD.GLOBAL.DEPTH1') }}</th>
                        <th>{{ $t('FIELD.GLOBAL.DEPTH2') }}</th>
                        <th>{{ $t('FIELD.GLOBAL.DEPTH3') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in mySettingMenu">
                        <td class="tC">{{item.COLDATA1}}</td>
                        <td class="tC">{{item.COLDATA2}}</td>
                        <td class="tC">{{item.COLDATA3}}</td>
                    </tr>
                    <tr v-if="mySettingMenu.length == 0" >
                        <td class="tC" conspan = '3' >{{ $t('MESSAGE.GLOBAL.NO.DATA') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!--list table-->
        <div class="grid_wrap">
            <!-- my Quick Category tit -->
            <div class="sub_tit mt-25 w100p">
                {{ $t('FIELD.GLOBAL.ETC.055') }}
                <a v-if="!isMobile" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnCatConfig">
                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                </a>
            </div>
            <!-- //my Quick Category tit -->
            <table class="scroll_table">
                <colgroup>
                    <col width="33.3%" />
                    <col width="33.3%" />
                    <col width="*" />
                </colgroup>
                <thead>
                    <tr>
                        <th>{{ $t('FIELD.GLOBAL.DEPTH1') }}</th>
                        <th>{{ $t('FIELD.GLOBAL.DEPTH2') }}</th>
                        <th>{{ $t('FIELD.GLOBAL.DEPTH3') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in mySettingCategory">
                        <td class="tC">{{item.COLDATA1}}</td>
                        <td class="tC">{{item.COLDATA2}}</td>
                        <td class="tC">{{item.COLDATA3}}</td>
                    </tr>
                    <tr v-if="mySettingCategory.length === 0" >
                        <td class="tC" conspan = '3' >{{ $t('MESSAGE.GLOBAL.NO.DATA') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="inquiry_content_wrap">

            <!--list table-->
            <div v-show="Number(deptLevelCd) > 1" class="grid_wrap">
                <!-- my Main Dashboard tit -->
                <div class="sub_tit mt-25 w100p">
                    {{ $t('FIELD.GLOBAL.ETC.054') }}
                    <a v-if="!isMobile" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnDashboardConfig">
                        <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                    </a>
                    <em v-if="!isMobile" class="ico_info">
                        <i class="tooltip">{{ $t('FIELD.GLOBAL.ETC.038') }}</i>
                    </em>
                </div>
                <table class="scroll_table">
                    <colgroup>
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>{{ $t('FIELD.GLOBAL.ETC.048') }}</th>
                            <th>{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</th>
                            <th>{{ $t('TITLE.SEARCH.CONTENTS.TYPE') }}</th>
                            <th>{{ $t('FIELD.GLOBAL.CATEGORY') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in mySettingDashboard">
                            <td class="tC">{{item.COLDATA1}}</td>
                            <td class="tC">{{item.COLDATA2}}</td>
                            <td class="tC">{{item.COLDATA3}}</td>
                            <td class="tC">{{item.COLDATA4}}</td>
                        </tr>
                        <tr v-if="mySettingDashboard.length === 0" >
                            <td class="tC" conspan = '4' >{{ $t('MESSAGE.GLOBAL.NO.DATA') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!--my Main Contents -->
            <div class="grid_wrap">
                <!-- My Inquiry Type tit -->
                <div class="sub_tit mt-25 w100p">
                    {{ $t('TITLE.DASHBOARD.MAIN.CONTENTS') }}
                    <a v-if="!isMobile" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnContentsConfig">
                        <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                    </a>
                    <em v-if="!isMobile" class="ico_info">
                        <i class="tooltip">{{ $t('FIELD.GLOBAL.ETC.037') }}</i>
                    </em>
                </div>
                <!--list table-->
                <table class="scroll_table">
                    <thead>
                        <tr>
                            <th>{{ $t('FIELD.GLOBAL.ETC.043') }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="mySettingContent.length > 0">
                        <tr>
                            <td class="tC">1. {{this.getContentName(mySettingContent[0].COLDATA1)}}</td>
                        </tr>
                        <tr>
                            <td class="tC">2. {{this.getContentName(mySettingContent[0].COLDATA2)}}</td>
                        </tr>
                        <tr>
                            <td class="tC">3. {{this.getContentName(mySettingContent[0].COLDATA3)}}</td>
                        </tr>
                    </tbody>
                    <tbody v-if="mySettingContent.length === 0">
                        <tr>
                            <td class="tC" >{{ $t('MESSAGE.GLOBAL.NO.DATA') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Others tit -->
            <div class="sub_tit mt-25 w100p">
                {{ $t('SUBTITLE.FAST.OTHERS') }}
            </div>
            <!-- //Others tit -->
            <!-- detail_table-->
            <table class="data_table">
                <colgroup>
                    <col width="150" />
                    <col width="*" />
                    <col width="150" />
                    <col width="*" />
                </colgroup>
                <tbody v-if="mySettingOther.length > 0">
                    <tr>
                        <th>{{ $t('FIELD.MYKNOWLEDGE.LISTOFCOUNT') }}</th>
                        <td>{{ mySettingOther[0].COLDATA1 }}</td>
                        <th>{{ $t('FIELD.SURVEY.SUMMARY.LANG') }}</th>
                        <td>{{ mySettingOther[0].COLDATA2 }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.USER.ENV.TIME.ZONE') }}</th>
                        <td>{{ mySettingOther[0].COLDATA3 }}</td>
                        <th>{{ $t('FIELD.GLOBAL.DATE') }}</th>
                        <td>{{ mySettingOther[0].COLDATA4 }}</td>
                    </tr>
                </tbody>
            </table>
            <!--//COPY detail_table-->
        </div>

    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                          from 'vue';
import { mapGetters, mapActions }   from 'vuex';
import _                            from 'lodash';
import $                            from 'jquery';
import axios                        from 'axios';
import qs                           from 'query-string';
import store                        from '@/vuex/store';
import { SDLUtil, StringUtil }      from '@/utils';
import { EventBus }                 from '@/utils/EventBus';

import SKPBreadcrumbs               from '~vb/main/SKPBreadcrumbs';

import MyMenuConfigPopup            from '~vb/common/MyMenuConfigPopup';
import CategoryConfigPopup          from '~vb/common/CategoryConfigPopup';
import DashboardConfigPopup         from '~vb/dashboard/popup/DashboardConfigPopup';
import ContentsConfigPopup          from '~vb/dashboard/popup/ContentsConfigPopup';

const fetchData = params => axios.post(
    `${SDLUtil.API_URL}/basis/common/getMysettingList.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

const fetchMySetting = workType => axios.post(
    `${SDLUtil.API_URL}/basis/main/getMySetting.skp`,
    qs.stringify({ workType: workType }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'UserPreferencesDetail',
    data() {
        return {
            pageTitle: '',
            resultData : [],
            mySettingOther: [],
            mySettingMenu: [],
            mySettingCategory: [],
            mySettingDashboard: [],
            mySettingContent: [],

            myChartSettings: [],
            myContentsList:[],

            isMobile: SDLUtil.isMobile()
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            myPages: 'getMyPages',
            storeParams: 'getParams',
            userCorpCd: 'getCorpCd',
            loginSystem: 'getLoginSystem',
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            deptLevelCd: 'getDeptLevelCd',
            locale: 'getLocale',
        }),
        getUserInfo() {
            return SDLUtil.getLoginedUserInfo();
        },
    },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
    },
    methods: {
        async mySettingList(workType) {
            return await fetchMySetting(workType);
        },
        async searchMyConfigsList(){
            SDLUtil.showLoadingBar(true);
            const response = await fetchData()
                .then(res => {
                    let data = res.data;
                    this.rowData = data.mysetting.rowData;
                    //console.log(this.rowData);
                    this.mySettingOther = this.rowData.filter(item => item.WORK_TYPE === 'OTHER');
                    this.mySettingMenu = this.rowData.filter(item => item.WORK_TYPE === 'MENU');
                    this.mySettingCategory = this.rowData.filter(item => item.WORK_TYPE === 'CATEGORY');
                    this.mySettingDashboard = this.rowData.filter(item => item.WORK_TYPE === 'DASHBOARD');
                    this.mySettingContent = this.rowData.filter(item => item.WORK_TYPE === 'CONTENT');
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        getContentName(content_type) {
            let contentName = '';
            if(content_type == 'H') contentName = SDLUtil.getMsgProp('FIELD.DASHBOARD.HOT.CONTENTS');
            if(content_type == 'W') contentName = SDLUtil.getMsgProp('FIELD.DASHBOARD.WORKBOARD');
            if(content_type == 'S') contentName = SDLUtil.getMsgProp('TITLE.LEFT.MENU.SUPPORT');
            if(content_type == 'N') contentName = SDLUtil.getMsgProp('FIELD.DASHBOARD.NEW.UPDATE');
            return contentName;
        },
        goMain() {
            store.commit( 'PARAMS', Object.assign( this.storeParams, { menuId : '', menuGrpCd : '', menuGrpDetailCd : '', creationYn : null } ) );
            if(this.loginSystem == 'SUPPORT') {
                this.$router.push(MenuUtil.getSupportMain());

            } else {
                this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
            }
        },

        // My Menu config
        btnMyMenuConfig() {
            SDLUtil.show(
                MyMenuConfigPopup,
                {
                    rtnFunc: () => {
                        // 팝업 닫은 후 내 메뉴 리로드
                        this.searchMyConfigsList();
                        EventBus.$emit('my-menus-reload');
                    }
                },
                { height: 'auto' }
            );
        },
        // Quick Category config
        btnCatConfig() {
            SDLUtil.show(
                CategoryConfigPopup,
                {
                    rtnFunc: () => {
                        // 팝업 닫은 후 카테고리 리로드
                        this.searchMyConfigsList();
                        EventBus.$emit('quick-category-reload');
                    }
                },
                { height: 'auto' }
            );
        },
        // 상단 대시보드 차트 설정 팝업
        btnDashboardConfig() {
            SDLUtil.show(
                DashboardConfigPopup,
                {
                    kpiList: this.myChartSettings.rowData || [],
                    rtnFunc: (isSaved = false) => {
                        SDLUtil.showLoadingBar(true);
                        this.isChartLoading = true;

                        this.$nextTick(() => {
                            if(isSaved){
                                this.toastPopup(SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'));
                                this.mySettingList("DASHBOARD").then( res => {
                                    let data = res.data;
                                    this.myChartSettings = data.mySetting;
                                    SDLUtil.showLoadingBar(false);
                                    this.$nextTick(() => {
                                        this.searchMyConfigsList();
                                    });
                                });

                            } else {
                                SDLUtil.showLoadingBar(false);
                            };
                        });
                    }
                },
                { height: 'auto' }
            );
        },
        // 하단 컨텐츠 설정 팝업
        btnContentsConfig() {
            SDLUtil.show(
                ContentsConfigPopup,
                {
                    contList: this.myContentsList,
                    rtnFunc: list => {
                        if(list.length > 0) {
                            this.toastPopup(SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'));
                            this.myContentsList = list;
                            this.$nextTick(() => {
                                this.searchMyConfigsList();
                            });
                        };
                    }
                },
                { height: 'auto' }
            );
        },
        toastPopup(msg) {
            Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
        },
    },
    mounted() {
        this.mySettingList("CONTENT").then( res => {
            let data = res.data;
            if(data.mySetting.rowCount > 0){
                this.myContentsList = data.mySetting.rowData;
            };
        });

        this.mySettingList("DASHBOARD").then( res => {
            let data = res.data;
            this.myChartSettings = data.mySetting;
        });

        this.searchMyConfigsList();
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/userPreferences/UserPreferencesDetail.vue